export default __webpack_public_path__ + "static/media/Ballroll_00232.9b8d1dbe.png";